// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalButton_button__fvboi"};